import { render, staticRenderFns } from "./Tariffs.yaml?vue&type=template&id=18314652&component"
import script from "./Tariffs.yaml?vue&type=script&lang=ts&component"
export * from "./Tariffs.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports